import http from './http';
import store from '../store';
import LocalStorage from "../services/localStorage";
import { unsubscribeToAllChannels } from '../services/pusher';
import router from "../router";

export default {
  // Register Routes
  billingInfo() {
    return http().get('/v1/registration/billing_info');
  },
  couponInfo(couponCode = null, promoCode = null) {
    return http().post('/v1/registration/coupon_info', {'coupon_code': couponCode, 'promo_code': promoCode});
  },
  register(data, validationErrors = {}) {
    return http(validationErrors).post('/v1/registration', data);
  },

  checkoutSessionInfo(sessionId) {
    return http().get(`v2/registration/${sessionId}`);
  },
  setupAccount(data, validationErrors = {}) {
    return http(validationErrors).post('/v2/registration', data)
      .then(response => {
        LocalStorage.setAuthUser(response.data.user);
        LocalStorage.setApiToken(response.data.api_token);
        LocalStorage.setAdminMode(response.data.is_admin);
        return {data: response.data}
      })
  },

  // Billing Routes
  billingPortalSession(email, password) {
    return http().post(`/v1/accounts/billing-portal`, {
      'email_address': email,
      'password': password
    });
  },
  customerPortalSession(email, password) {
    return http().post(`v1/accounts/resignup-portal`, {
      'email_address': email,
      'password': password
    });
  },

  // Login Routes
  login(loginForm, validationErrors = {}) {
    return http(validationErrors).post('/v1/login', loginForm)
      .then(response => {
        LocalStorage.setAuthUser(response.data.user);
        LocalStorage.setApiToken(response.data.api_token);
        LocalStorage.setAdminMode(response.data.is_admin);

        return {data: response.data.user}
      });
  },
  loginViaToken(token, validationErrors = {}) {
    return http(validationErrors).post(`v1/login/temporary_auth_token/${token}`, [])
      .then(response => {
        LocalStorage.setAuthUser(response.data.user);
        LocalStorage.setApiToken(response.data.api_token);
        LocalStorage.setAdminMode(response.data.is_admin);

        return {data: response.data.user}
      });
  },

  continueSession() {
    return http().get('/v1/continue_session')
    .then(response => {
      return response;
    });
  },
  logout() {
    return http().post('/v1/logout')
      .then(() => {
        LocalStorage.removeApiToken();
        LocalStorage.removeAuthUser();
        LocalStorage.removeAdminMode();

        unsubscribeToAllChannels();
        store.commit('clearMetadata');
        store.commit('setAppIsInitiated', false);

        LocalStorage.clear();
      })
  },
  forgotPassword(data) {
    return http().post('/v1/password/email', data);
  },
  resetPassword(data) {
    return http().post(`/v1/password/reset`, data).then((response) => {
      LocalStorage.setAuthUser(response.data.user);
      LocalStorage.setApiToken(response.data.api_token);
      LocalStorage.setAdminMode(response.data.is_admin);

      return {data: response.data.user}
    });
  },
}
